/** Demoens egne lagringsnøkler. «Nullstill demo» fjerner kun disse. */
export const STORAGE_PREFIX = 'hr-demo:';

export const KEYS = {
  session: `${STORAGE_PREFIX}session`,
  lastView: `${STORAGE_PREFIX}lastView`,
  adapter: `${STORAGE_PREFIX}adapter`,
  rates: `${STORAGE_PREFIX}rates`,
  importRows: (scenarioId) => `${STORAGE_PREFIX}import:${scenarioId}`,
  store: (scenarioId, seedVersion) => `${STORAGE_PREFIX}store:${scenarioId}:${seedVersion}`,
  syncState: `${STORAGE_PREFIX}syncState`,
};

export function readJson(storage, key, fallback) {
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignorer kvotefeil i demo */
  }
}

/** Fjerner alle demoens lagringsnøkler (localStorage), valgfritt også økten. */
export function clearDemoStorage({ includeSession = false } = {}) {
  const removeFrom = (storage) => {
    const keys = [];
    for (let i = 0; i < storage.length; i++) {
      const k = storage.key(i);
      if (k && k.startsWith(STORAGE_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => {
      if (!includeSession && k === KEYS.session) return;
      storage.removeItem(k);
    });
  };
  removeFrom(window.localStorage);
  if (includeSession) removeFrom(window.sessionStorage);
}
